import React, { useEffect, useState } from "react";
import { storyblokEditable, StoryblokComponent } from "@storyblok/react";
import { BasicPanelModel } from "./BasicPanelModel";

import "./BasicPanel.css";
import { themeService } from "../../core/NotificationStripNav/ThemeService";
import { Theme } from "../../core/Models/CustomSiteConfigModel";

const BasicPanelPanel: React.FC<{ blok: BasicPanelModel }> = ({ blok }) => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  return (
    <div
      {...storyblokEditable(blok)}
      className="basic-panel"
      style={{ backgroundColor: theme?.panelColour, color: theme?.textColor }}
    >
      {blok.content
        ? blok.content.map((blokk) => (
            <StoryblokComponent blok={blokk} key={blokk._uid} />
          ))
        : null}
    </div>
  );
};

export default BasicPanelPanel;
